import 'reflect-metadata'
import { createApp } from 'vue'
import { IonicVue } from '@ionic/vue'
import { createPinia } from 'pinia'
import { FirebaseAppCheck } from '@capacitor-firebase/app-check'
import { initSafeArea } from './helpers/safeArea'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import veProgress from 'vue-ellipse-progress'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueResizeObserver from 'vue-resize-observer'
import App from '@/App.vue'
import router from '@/router'

import * as ExceptionReportingManager from './classes/manager/ExceptionReportingManager'

import { i18nInstance } from '@/locales/locales'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'
/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'
import '@ionic/vue/css/padding.css'
import { icons } from '@/icons'

import './index.css'

/* import the fontawesome icon library and register used icons globally */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createVuetify } from 'vuetify'
import { VTab, VTabs } from 'vuetify/components/VTabs'

import {
  dateTime,
  dateTimeLong,
  date,
  time,
} from '@/helpers/filters/dateTimeFilters'
import { Device } from '@capacitor/device'
import Vue3Lottie from 'vue3-lottie'
import './firebase-messaging-sw-dev.js'
import PrimeVue from 'primevue/config'
import { definePreset } from '@primevue/themes'
import Lara from '@primevue/themes/lara'
import { primeVuePreset } from '@/theme'

library.add(...icons)

import { defineCustomElements } from '@ionic/pwa-elements/loader'
void defineCustomElements(window)

const app = createApp(App)

const globalFilters = { dateTime, dateTimeLong, date, time }
app.config.globalProperties.$filters = globalFilters

declare module 'vue' {
  export interface ComponentCustomPπroperties {
    $filters: typeof globalFilters
  }
}

try {
  ExceptionReportingManager.init(import.meta.env.MODE, app)
} catch (e) {
  console.error('Error initializing Sentry failed', e)
}

const vuetify = createVuetify({
  components: [VTab, VTabs],
})

void Device.getInfo().then((info) => {
  // appCheck not working in webbrowser
  if (info.platform === 'web') {
    return
  }
  //appCheck debug = if its running on a real device
  //if debug = false check android logcat for AppCheck debug secret and enter it in firebase console

  void FirebaseAppCheck.initialize({
    debug: info.isVirtual,
    siteKey: '6Ldft7EaAAAAAEMmFZI_6dWIE-njIHeBfmaiQ3yT',
  })
})
const primevuePreset = definePreset(Lara, primeVuePreset)

initSafeArea()

app
  .use(createPinia())
  .use(IonicVue)
  .use(router)
  .use(veProgress)
  .use(vuetify)
  .use(i18nInstance)
  .use(VueResizeObserver)
  .use(Vue3Lottie, { name: 'lottie-player' })
  .use(PrimeVue, {
    theme: {
      preset: primevuePreset,
      options: {
        darkModeSelector: 'light',
      },
    },
  })

  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')

window.oncontextmenu = function () {
  return false
}
